module.exports = __webpack_public_path__ + "static/media/employee.49c7073d.webp";